(function() {
	document.addEventListener('DOMContentLoaded', () => {
		const tabs = document.querySelectorAll('.main-product-tabbed-text__tab button');
		const richtextSections = document.querySelectorAll('.main-product-tabbed-text__section');

		tabs.forEach(tab => {
			tab.addEventListener('click', () => {

				if (tab.innerText == 'Size Guide') {
					document.querySelector('.main-product-tabbed-text').classList.add('hide-image');
				} else {
					if (document.querySelector('.main-product-tabbed-text').classList.contains('hide-image')) {
						document.querySelector('.main-product-tabbed-text').classList.remove('hide-image');
					}
				}

				tabs.forEach(button => {
					button.classList.remove('current');
					button.setAttribute('aria-selected', false);
				});

				richtextSections.forEach(section => {
					if (section.classList.contains(tab.dataset.target)) {
						tab.classList.add('current');
						tab.setAttribute('aria-selected', true);
						section.setAttribute('aria-hidden', false);
						section.classList.add('visible');
					} else {
						section.setAttribute('aria-hidden', true);
						section.classList.remove('visible');
					}
				});
			});
		});
	});
})();
